export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_DOCUMENTS_CATEGORIES = 'SET_DOCUMENTS_CATEGORIES';
export const SET_CANDIDATE_FORM_PAGE = 'SET_CANDIDATE_FORM_PAGE';

export const CHANGE_USER = 'CHANGE_USER';
export const PATCH_CANDIDATE = 'PATCH_CANDIDATE';
export const CLEAR_CANDIDATE = 'CLEAR_CANDIDATE';
export const SET_IS_ADDITIONAL_DOCS_SENDED = 'SET_IS_ADDITIONAL_DOCS_SENDED';
export const SET_CURRENT_CANDIDATE_DATA = 'SET_CURRENT_CANDIDATE_DATA';
export const SET_IS_DOCS_LOADING = 'SET_IS_DOCS_LOADING';

export const ERROR = 'ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const LANGUAGE = 'LANGUAGE';
export const IS_LANGUAGE_LOADING = 'IS_LANGUAGE_LOADING';

export const NEW_EMPLOYER = 'NEW_EMPLOYER';
export const GET_EMPLOYER = 'GET_EMPLOYER';

export const CHANGE_DAY = 'CHANGE_DAY';
export const SET_ACTIVE_HOUR = 'SET_ACTIVE_HOUR';
export const SET_CALENDAR = 'SET_CALENDAR';
export const SET_REQUEST_ACCEPT = 'SET_REQUEST_ACCEPT';
export const SET_POPUP_ACTIVE = 'SET_POPUP_ACTIVE';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_GMT_CHANGED = 'SET_GMT_CHANGED';

export const SET_CONFIRM_TOKEN = 'CONFIRM_CV';
